import { QNA_STATUS } from '../platform/qnaConstants';

class QnAQuestion {
  constructor({
    id,
    title,
    body,
    status,
    uid,
    displayName,
    createdAt,
    unit,
    unitName,
    order,
    lastActivityAt,
    answeredAt,
    answeredByUid,
    answeredByName,
  }) {
    this.id = id || null;
    this.title = title || '';
    this.body = body || '';
    this.status = status || QNA_STATUS.OPEN;
    this.uid = uid || null;
    this.displayName = displayName || 'Anonimen';
    this.createdAt = createdAt || null;
    this.unit = unit || 'general';
    this.unitName = unitName || 'Splošno';
    this.order = order || 0;
    this.lastActivityAt = lastActivityAt || null;
    this.answeredAt = answeredAt || null;
    this.answeredByUid = answeredByUid || null;
    this.answeredByName = answeredByName || null;
  }

  get displayBody() {
    return this.body?.trim() || this.title || '';
  }

  toFirestore() {
    return {
      title: this.title,
      body: this.body,
      status: this.status,
      uid: this.uid,
      displayName: this.displayName,
      createdAt: this.createdAt,
      unit: this.unit,
      unitName: this.unitName,
      order: this.order,
      ...(this.lastActivityAt ? { lastActivityAt: this.lastActivityAt } : {}),
      ...(this.answeredAt ? { answeredAt: this.answeredAt } : {}),
      ...(this.answeredByUid ? { answeredByUid: this.answeredByUid } : {}),
      ...(this.answeredByName ? { answeredByName: this.answeredByName } : {}),
    };
  }

  static fromFirestore(snapshot) {
    const data = snapshot.data();
    return new QnAQuestion({
      id: snapshot.id,
      title: data.title,
      body: data.body,
      status: data.status || QNA_STATUS.OPEN,
      uid: data.uid,
      displayName: data.displayName,
      createdAt: data.createdAt ? data.createdAt.toDate() : null,
      unit: data.unit || 'general',
      unitName: data.unitName || 'Splošno',
      order: data.order || 0,
      lastActivityAt: data.lastActivityAt ? data.lastActivityAt.toDate() : null,
      answeredAt: data.answeredAt ? data.answeredAt.toDate() : null,
      answeredByUid: data.answeredByUid || null,
      answeredByName: data.answeredByName || null,
    });
  }
}

export default QnAQuestion;
